import { clone } from 'lodash';

class PropertyFormController {
  constructor($scope, $state, propertiesService, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.propertiesService = propertiesService;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit(){
    this.property.currency_symbol = this.property.currency_symbol || "£";
    this.property.close_out = this.property.close_out || '';
    this.property.timezone = this.property.timezone || 'Europe/London';
  }

  timeRange() {
    let starttime = (this.property.property_day_start && this.property.property_day_start.includes(':') ? this.property.property_day_start.split(':')[0] : 9);
    let endtime = (this.property.property_day_end && this.property.property_day_end.includes(':') ? this.property.property_day_end.split(':')[0] : 18);

    let timeRange = [];

    for (let i = starttime; i <= endtime; i++) {
        let time = i.toString().padStart(2, '0');
        timeRange.push(time);
     }
     return timeRange;
  }

  onSave() {
    let dispatch = clone(this.property);

    return this.propertiesService.save(dispatch)
      .then(response => {
        if (this.property.id) {
          this.messageService.success(`The Property <strong>${this.property.name}</strong> was successfully updated!`);
        }else{
          this.messageService.success(`The Property <strong>${this.property.name}</strong> was successfully created!`, [`app.admin.property-edit({ 'property' : ${this.property.id}})`, `Property`]);
        }
        this.$state.go('app.admin.properties');
        this.messageService.push();
      })
      .catch((error) => {
        error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

        let sourceElement = Object.keys(error.data);
        let verb = 'created';
        if ( this.property.id ) {
          verb = 'updated';
        }
        if ( sourceElement.length > 0 ) {
          let errors = '';
          for ( let element of sourceElement ) {
            errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
          }
          this.messageService.failure(`The property <strong>${this.property.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
        } else {
          this.messageService.failure(`The property <strong>${this.property.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
        }
        this.messageService.push();
      });
  }
}

PropertyFormController.$inject = [ '$scope', '$state', 'propertiesService', 'messageService', 'access' ];

export default PropertyFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.form.controller.js